<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 18 18"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M15.333 13h-2c-.184 0-.333-.15-.333-.333 0-.184.15-.334.333-.334h2c.552 0 1-.448 1-1V6.667c0-.552-.448-1-1-1H2.667c-.552 0-1 .448-1 1v4.666c0 .552.448 1 1 1h2c.184 0 .333.15.333.334 0 .184-.15.333-.333.333h-2C1.747 13 1 12.252 1 11.333V6.667C1 5.748 1.747 5 2.667 5h12.666C16.253 5 17 5.748 17 6.667v4.666c0 .919-.747 1.667-1.667 1.667zM10.667 15h-4c-.184 0-.334-.15-.334-.333 0-.184.15-.334.334-.334h4c.184 0 .333.15.333.334 0 .184-.15.333-.333.333zM10.667 13.667h-4c-.184 0-.334-.15-.334-.334 0-.184.15-.333.334-.333h4c.184 0 .333.15.333.333 0 .184-.15.334-.333.334z"
        transform="translate(-1328 -710) translate(1328 710)"
      />
      <path
        d="M13.333 5.667c-.184 0-.333-.15-.333-.334V2.667c0-.552-.449-1-1-1H6c-.551 0-1 .448-1 1v2.666c0 .184-.15.334-.333.334-.184 0-.334-.15-.334-.334V2.667C4.333 1.748 5.081 1 6 1h6c.92 0 1.667.748 1.667 1.667v2.666c0 .184-.15.334-.334.334zM12 17H6c-.92 0-1.667-.748-1.667-1.667V10c0-.184.15-.333.334-.333h8.666c.184 0 .334.149.334.333v5.333c0 .919-.748 1.667-1.667 1.667zm-7-6.667v5c0 .552.449 1 1 1h6c.551 0 1-.448 1-1v-5H5z"
        transform="translate(-1328 -710) translate(1328 710)"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-print",
  components: {},
})
export class IconPrint extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconPrint;
</script>
